// extracted by mini-css-extract-plugin
export default {"description":"style_description__UltDn","fade-in":"style_fade-in__ZILm1","top":"style_top__WD8uY","image":"style_image__0BQ6E"};